import { formatAmount } from './formatters';

export const required = value => {
  if (value === undefined || value === null || value === '') return 'This field is required';
  return undefined;
};

export const minAmount = (min, value) => {
  if (value < min) return `Must be at least ${formatAmount(min)}`;
  return undefined;
};

export const maxAmount = (max, value) => {
  if (value > max) return `Must be no greater than ${formatAmount(max)}`;
  return undefined;
};

export const rangeAmount = (min, max, value) => {
  if (minAmount(min, value) || maxAmount(max, value)) return `Choose from ${formatAmount(min)} - ${formatAmount(max)}`;
  return undefined;
};

export const rangeConsolidationAmount = (loanAmount, value) => {
  if (minAmount(1, value)) return 'Must be greater than zero';
  if (maxAmount(loanAmount, value)) return 'Cannot be greater than loan amount';
  return undefined;
};

export const minLength = (minLength, value) => {
  if (value && value.length < minLength) return `The number of characters entered cannot be less than ${minLength}`;
  return undefined;
};

export const maxLength = (maxLength, value) => {
  if (value && value.length > maxLength) return `The number of characters entered cannot be more than ${maxLength}`;
  return undefined;
};


export const email = (value) => {
  const regex = new RegExp('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$');
  if (!regex.test(value)) return 'Please use standard email format, xxx@xxx.xxx. Enter only letters, numbers, (.) period, (-) hyphen, (_) underline or @';
  return undefined;
};

export const compareTo = (otherProvider, value) => {
  let otherValue = otherProvider();
  if (otherValue.toLowerCase() !== value.toLowerCase()) return 'Your confirm email must match your email';
  return undefined;
};

export const monthsAtResidence = (value) => {
  const regex = new RegExp('^(0|0[0-9]|[1-9]|1[01])$');
  if (!regex.test(value)) return 'Please enter a valid value for months at residence';
  return undefined;
};

export const validateAddress = (value) => {
  const regex = new RegExp("^[a-zA-Z0-9\\' \\.,&#/-]+$");
  if(value !== '' && !regex.test(value)) return "Cannot contain any special characters other than (.) period, (,) comma, (-) dash, (&) ampersand, (#) hash, (/) forward slash and (') apostrophe";
  return undefined;
};

export const validateCity = value => {
  const regex = new RegExp('^[a-zA-Z\\- ]+$');
  if(!regex.test(value)) return 'Cannot contain any special characters other than (-) dash, space';
  return undefined;
};

export const alphaName = value => {
  const regex = new RegExp("^[a-zA-Z' -]+$");
  if(value !== '' && !regex.test(value)) {
    return "Cannot contain any numbers or special characters other than (-) dash, (') apostrophe, space";
  }
  return undefined;
};

export const validateDate = value => {
  //No handling for leap years
  const regex = new RegExp('^(0?0[0-9]|1[012])(0?[1-9]|[12][0-9]|3[01])([1-9][0-9][0-9][0-9])$');
  if(!regex.test(value)) return 'Date is invalid';
  return undefined;
};

export const checked = value => {
  if (value !== true) return 'You must check the box to proceed';
  return undefined;
};

export const printable = value => {
  const regex = new RegExp('^[\\w\\s!"#$%&\'()*+,-./:;<=>?@\\\\^_`{}~\\[\\]]*$');
  if(!regex.test(value)) return "Only alphanumeric, punctuation and space characters are allowed";
  return undefined;
};

export const notEmpty = value => {
  if (value.trim() === '') return 'Cannot be empty';
  return undefined;
};
